<template>
    <div
        class="py-2 px-2 my-2 border border-gray-200 flex flex-col w-full hover:bg-gray-100"
    >
        <div class="flex justify-between items-center">
            <!-- NAME AND INFO -->
            <div>
                <div class="font-semibold">{{ rate.name }}</div>
                <div class="text-xs font-mono text-minplan-grey">
                    {{ $t("taxRates.value") }}
                    <span class="font-mono">{{ rate.value }}%</span> |
                    {{ $t("taxRates.code") }}
                    <span class="font-mono">{{ rate.code }}</span>
                </div>
            </div>

            <div class="flex items-center gap-2">
                <!-- CASE IS STANDARD VAT RATE -->
                <span
                    v-if="rate.is_default"
                    class="text-xs font-semibold bg-lime-100 text-lime-800 px-2 py-1 rounded-full"
                >
                    {{ $t("taxRates.standardVat") }}
                </span>

                <!-- CASE IS NOT STANDARD VAT RATE : SHOW OPTIONS -->
                <template v-else>
                    <button @click="onMakeDefault(rate)" title="Make Default">
                        <CheckCircleIcon
                            class="h-5 w-5 text-minplan-grey hover:text-lime-500"
                        />
                    </button>
                    <button @click="onDelete(rate.id)" title="Delete">
                        <TrashIcon class="h-5 w-5 text-minplan-grey hover:text-red-500" />
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { SearchIcon, CheckCircleIcon, TrashIcon } from "@heroicons/vue/outline";

export default {
    props: ["rate", "onDelete", "onMakeDefault"],
    components: { SearchIcon, CheckCircleIcon, TrashIcon },
};
</script>

<style scoped></style>
